import AuthService from './auth-service'
import MockAuthService from './mock-auth-service'
import ApiService from './api-service'
import MockApiService from './mock-api-service'

const isMock = import.meta.env.VITE_MOCK === 'true'

export const auth = isMock ? new MockAuthService() : new AuthService()
export const api: InstanceType<typeof ApiService> | InstanceType<typeof MockApiService> = isMock
  ? new MockApiService()
  : new ApiService(auth)

export type { IAuthService } from './auth-service'
export type { IApiService } from './api-service'
